<template>
  <div>
    <east-operate>
      <template #left>
        <el-button size="mini" type="danger" @click="handleDelete" icon="el-icon-delete">删除</el-button>
      </template>
      <template #right>
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="mini"
        ></el-date-picker>
        <el-select
          v-model="search.device"
          placeholder="设备"
          style="width:120px"
          size="mini"
          clearable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          placeholder="请输入关键字"
          style="width:200px"
          size="mini"
          v-model="search.keyword"
          clearable
        >
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            title="搜索日志"
            @click="fetchData"
            slot="append"
          ></el-button>
        </el-input>
      </template>
    </east-operate>
    <el-table
      ref="logsTable"
      :data="tableData.list"
      tooltip-effect="dark"
      :empty-text="emptyText"
      @selection-change="handleSelectionChange"
      :height="tableHeight"
      v-loading="loading"
    >
      <el-table-column type="selection" width="50" align="center" fixed="left"></el-table-column>
      <el-table-column prop="account" label="账号"></el-table-column>
      <el-table-column prop="loginTime" label="登录时间" :formatter="formatter"></el-table-column>
      <el-table-column prop="device" label="设备"></el-table-column>
      <el-table-column prop="ip" label="IP"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="
                            handleSelectionChange([scope.row])
                            handleDelete()
                        "
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="search.page"
      :page-sizes="[20, 30, 50, 80, 100]"
      :page-size="search.size"
      layout="total, sizes, prev, pager, next"
      :total="tableData.total"
    ></el-pagination>
  </div>
</template>
<script>
import EastOperate from "../../../components/east-operate";
import { formatDate } from "../../../libs/date";
import { getLogs, deleteLogs } from "../../../api/gm/api-loginlog";
export default {
  data() {
    return {
      options: [
        {
          value: "PC",
          label: "PC"
        },
        {
          value: "手机",
          label: "手机"
        }
      ],
      search: {
        device: "",
        keyword: "",
        stime: "",
        etime: "",
        size: 20,
        page: 1
      },

      time: ["", ""],
      tableHeight: window.innerHeight - 185,
      tableData: {},
      emptyText: " ",
      multipleSelection: [],
      loading: true
    };
  },
  computed: {
    // ...mapState(['user'])
  },
  components: {
    "east-operate": EastOperate
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  mounted() {
    window.addEventListener("resize", () => this.measure(), false);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measure(), false);
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData"
  },
  methods: {
    measure() {
      this.tableHeight = window.innerHeight - 185;
    },
    fetchData() {
      if (this.time === null) {
        this.time = ["", ""];
      }
      this.search.stime = this.time[0] || "";
      this.search.etime = this.time[1] || "";
      getLogs(this.search).then(res => {
        this.loading = false;
        if (res.code === 0) {
          this.tableData = res.data;
        } else {
          this.emptyText = res.msg;
        }
      });
    },
    formatter(row, column) {
      return formatDate(new Date(row.loginTime), "yyyy/MM/dd hh:mm");
    },
    handleSizeChange(val) {
      this.search.size = val;
      this.search.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.fetchData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(it => {
        return it.id;
      });
    },
    handleDelete() {
      if (this.multipleSelection.length === 0) {
        this.$notify.warning({
          title: "提示",
          message: "请选择要删除的日志",
          duration: 1500
        });
      } else {
        this.$confirm("删除不可恢复,确认?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        })
          .then(() => {
            deleteLogs(this.multipleSelection).then(res => {
              if (res.code === 0) {
                this.search.page = 1;
                this.fetchData();
                this.$notify.success({
                  title: "成功",
                  message: "日志删除成功",
                  duration: 1500
                });
              } else {
                this.$notify.error({
                  title: "失败",
                  message: "日志删除失败",
                  duration: 1500
                });
              }
            });
          })
          .catch(() => {});
      }
    }
  }
};
</script>
<style lang="less">
.el-pagination {
  padding: 10px 5px;
}
.el-date-editor {
  width: 220px !important;
  .el-range-separator {
    color: #555555 !important;
    position: relative;
    margin-top: -2px;
  }
}
.view-table {
  overflow: auto;
  font-size: 14px;
  .el-drawer__header {
    margin-bottom: 10px;
    padding: 15px;
  }
  table {
    margin: 0 10px;
    font-size: 13px;
    tr {
      line-height: 25px;
      td:first-child {
        padding-left: 5px;
        width: 100px;
        i {
          font-size: 16px;
          color: #0081fa;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/gm/loginlog/index.vue